// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8704":"fad978fda66214c5","9001":"1806c2a5a0ba20dc","9544":"5f4f5e5bb479a1b9"}[chunkId] + ".css";
};